export { default as SummaryTab } from './SummaryTab';
export { default as QuizTab } from './QuizTab';
export { default as ChatTab } from './ChatTab';
export { default as FlashcardsTab } from './FlashcardsTab';
export { default as MindmapTab } from './MindmapTab';
export { default as TranscriptTab } from './TranscriptTab'; 